/**
 * QueryProvider - Provider principal pour TanStack Query
 * Encapsule la configuration et les devtools
 */

import React from 'react';
import { QueryClientProvider, ReactQueryDevtools, queryClient } from '../config/queryClient';

interface QueryProviderProps {
  children: React.ReactNode;
}

export function QueryProvider({ children }: QueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* DevTools uniquement en développement */}
      {import.meta.env.DEV && (
        <ReactQueryDevtools 
          initialIsOpen={false} 
          buttonPosition="bottom-left"
        />
      )}
    </QueryClientProvider>
  );
}

export default QueryProvider;
